import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ROUTES } from './constants/routes';
import {
  UserIdProvider,
  IndustryProvider,
  UserServiceProvider,
  ApprovalServiceProvider,
} from './context';
import Layout from 'src/layout/layout';
import AuthErrorDialog from 'src/components/authErrorDialog';
import AuthSigninProvider from 'src/components/authSigninProvider';

const Setup = lazy(() => import('src/pages/setup'));
const Home = lazy(() => import('src/pages/home'));
const ApplicationForm = lazy(() => import('src/pages/applicationForm'));

const App: React.FC = () => (
  <Router>
    <AuthSigninProvider>
      <ApprovalServiceProvider>
        <UserServiceProvider>
          <UserIdProvider>
            <IndustryProvider>
              <Suspense>
                <AuthErrorDialog />
                <Routes>
                  <Route path="/signin-oidc" element={<Setup />}/>
                  <Route path="/" element={<Setup />} />
                  <Route path={ROUTES.setup} element={<Setup />} />
                  <Route
                    path={ROUTES.home}
                    element={
                      <Layout>
                        <Home />
                      </Layout>
                    }
                  />
                  <Route
                    path={ROUTES.applicationForm}
                    element={
                      <Layout>
                        <ApplicationForm />
                      </Layout>
                    }
                  />
                </Routes>
              </Suspense>
            </IndustryProvider>
          </UserIdProvider>
        </UserServiceProvider>
      </ApprovalServiceProvider>
    </AuthSigninProvider>
  </Router>
);

export default App;
